import { FiscalEventType } from '../../types/fiscal/FiscalEvent';

const labels: Record<FiscalEventType, string> = {
  RETURN: 'Retorno', SPECIAL_OPERATIONS: 'Operaciones especiales',
  INVALIDATION: 'Invalidación', CONTINGENCY: 'Contingencia',
};
export default function FiscalEventTypeBadge({ type }: { type: FiscalEventType }) {
  return <span className="inline-flex rounded bg-primary/10 px-2 py-1 text-xs font-medium text-primary">{labels[type] ?? type}</span>;
}
